import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { P, Text } from '@mxenabled/mxui'

import { type FinstrongCopy } from '../../core'

interface HealthChartProps {
  copy: FinstrongCopy
}

const HealthChart = ({ copy }: HealthChartProps) => {
  const theme = useTheme()

  const gradientColors = [
    theme.palette.chartMono.chartMono5,
    theme.palette.chartMono.chartMono4,
    theme.palette.chartMono.chartMono3,
    theme.palette.chartMono.chartMono2,
  ]
  return (
    <Stack sx={{ gap: 8 }}>
      <Stack sx={{ flexDirection: 'row', gap: 8, px: 2 }}>
        {[
          { color: 'chartMono.chartMono2', text: copy.vulnerable, value: '0-25' },
          { color: 'chartMono.chartMono3', text: copy.building, value: '26-50' },
          { color: 'chartMono.chartMono4', text: copy.stable, value: '51-75' },
          { color: 'chartMono.chartMono5', text: copy.strong, value: '76-100' },
        ].map(({ color, text, value }) => (
          <Stack key={text} sx={{ gap: 4, textAlign: 'center', width: '100%' }}>
            <Box>
              <P sx={{ fontWeight: 700, textTransform: 'uppercase' }} variant="caption">
                {text}
              </P>
              <Text sx={{ color: 'text.secondary' }} variant="caption">
                ({value})
              </Text>
            </Box>
            <Box sx={{ border: '2px solid', borderColor: color, borderRadius: '3px' }} />
          </Stack>
        ))}
      </Stack>
      <Box>
        <Box
          sx={{
            background: `linear-gradient(to left, ${gradientColors.join(', ')})`,
            borderRadius: '4px',
            height: 16,
          }}
        />
        <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value) => (
            <Stack
              key={value}
              sx={{ alignItems: 'center', height: 20, justifyContent: 'space-between', width: 24 }}
            >
              <Box
                sx={{
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                  position: 'relative',
                  rotate: '90deg',
                  top: 3.5,
                  width: 8,
                }}
              />
              <Text sx={{ color: 'text.secondary' }} variant="tiny">
                {value}
              </Text>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  )
}

export default HealthChart
